import { SET_BULK_COMPOSER_INVOICE, CLEAR_PARAMS_COMPOSER_INVOICE, SET_PARAMS_COMPOSER_INVOICE } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    status: "",
    year: "",
    dsp_id: "",
    composer_id: "",
    start_date: "",
    end_date: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_COMPOSER_INVOICE:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_COMPOSER_INVOICE:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_COMPOSER_INVOICE:
            return initialState;
        default:
            return state;
    }
}
